module.exports = __webpack_public_path__ + "faa9c5d69db77db7490e96ee2c1ffbc5.png";